import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Container, Row, Col, Form, Collapse, Pagination } from 'react-bootstrap'
import clsx from 'clsx'
import { useIntl } from 'react-intl'
import DropdownIcon from '../../../../media/shared-access/ic-dropdown.svg'
import FilterIcon from '../../../../media/resources/icons/ic-filter.svg'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import { getFounderMarketClaimedDeals, getFounderMarketDeals } from '../core/_requests'
import { useAuth } from '../../auth'
import DealsFullWidthCard from './DealsFullWidthCard'
import FilterIconFunnel from '../../../../media/resources/icons/filterIcon.svg'
import Skeleton from 'react-loading-skeleton'
import { NoDataPage } from '../../resources/components/NoDataPage'
// import FounderCrateBlueBG from '../assets/founderCrate-blue-bg.png'
import EditDealFounderMarket from './EditDealModal'

interface FounderMarketOverviewProps {
  type: string
}

export const FounderMarketDeals: React.FC<FounderMarketOverviewProps> = ({ type }) => {
  const [founderMarketDeals, setFounderMarketDeals] = useState<any[]>([])
  const [, setFounderMarketClaimedDeals] = useState<any[]>([])
  const { formatMessage } = useIntl()
  const { companyId } = useAuth()
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [dealsPerPage, setDealsPerPage] = useState<number>(10)
  const [search, setSearch] = useState<string>('')
  const [sortBy, setSortBy] = useState<string>('name')
  const [sortOrder, setSortOrder] = useState<string>('ASC')
  const [count, setCount] = useState<number>(0)
  const [pageNumbers, setPageNumbers] = useState<number[]>([])
  const [open, setOpen] = useState(true)
  const [showCategories, setShowCategories] = useState(false)
  const [isactiveModal, setIsActiveModal] = useState(false)
  const [loading, setLoading] = useState<boolean>(true)
  // const [isExpanded, setIsExpanded] = useState(false);
  // const toggleReadMore = () => {
  //   setIsExpanded(!isExpanded);
  // };
  // const fullText = "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s...";
  // const truncatedText = "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has bee...";


  const categories = [
    { label: 'All', value: 'All' },
    { label: 'Cloud', value: 'Cloud' },
    { label: 'CRM', value: 'CRM' },
    { label: 'Finance', value: 'Finance' },
    { label: 'Tech', value: 'Tech' },
    { label: 'Productivity', value: 'Productivity' },
    { label: 'Social Media Management', value: 'Social Media Management' },
    { label: 'Automation', value: 'Automation' },
    { label: 'Software Tools', value: 'Software Tools' },
    { label: 'Productivity Tools', value: 'Productivity Tools' },
  ]
  const [selectedCategories, setSelectedCategories] = useState<string[]>(
    categories.map((cat) => cat.value)
  )
  const [category, setCategory] = useState<string>(categories.map((cat) => cat.value).join(', '))

  const getAllFounderMarketDeals = async () => {
    try {
      // setLoading(true)
      if (companyId) {
        const {
          data: { data, errors, success },
        } = await getFounderMarketDeals(
          companyId,
          currentPage,
          dealsPerPage,
          search,
          category,
          sortBy,
          sortOrder
        )
        if (success) {
          setCount(data.totalRecords)
          setFounderMarketDeals(data.marketDeals)
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }

  const getAllFounderMarketClaimedDeals = useCallback(async () => {
    try {
      setLoading(true)
      if (companyId) {
        const {
          data: { data: claimData, errors, success },
        } = await getFounderMarketClaimedDeals(companyId)
        if (success) {
          setFounderMarketClaimedDeals(claimData)
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }, [formatMessage, companyId])

  useEffect(() => {
    if (type !== 'deals') {
      getAllFounderMarketClaimedDeals()
    }
  }, [type, getAllFounderMarketClaimedDeals])

  useEffect(() => {
    if (type === 'deals') {
      getAllFounderMarketDeals()
    }
  }, [type, currentPage, dealsPerPage, category, sortBy, sortOrder]) // eslint-disable-line

  const dropdownRef = useRef<HTMLDivElement>(null)
  const [isOpen, setIsOpen] = useState(false)
  const toggleDropdown = () => {
    setIsOpen(!isOpen)
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  useEffect(() => {
    const calculatePageNumbers = () => {
      const pages = []
      for (let i = 1; i <= Math.ceil(count / dealsPerPage); i++) {
        pages.push(i)
      }
      setPageNumbers(pages)
    }

    calculatePageNumbers()
  }, [count, dealsPerPage])

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedCategory = event.target.value
    let updatedCategories = [...selectedCategories]

    if (selectedCategory === 'All') {
      if (event.target.checked) {
        updatedCategories = categories.map((cat) => cat.value)
      } else {
        updatedCategories = ['category']
      }
    } else {
      if (event.target.checked) {
        updatedCategories.push(selectedCategory)
      } else {
        updatedCategories = updatedCategories.filter((cat) => cat !== selectedCategory)
      }
    }

    setSelectedCategories(updatedCategories)
    setCategory(updatedCategories.join(', '))
  }

  useEffect(() => {
    if (
      selectedCategories.length === categories.length - 1 &&
      !selectedCategories.includes('All')
    ) {
      setSelectedCategories([...selectedCategories, 'All'])
    } else if (
      selectedCategories.length !== categories.length &&
      selectedCategories.includes('All')
    ) {
      setSelectedCategories(selectedCategories.filter((cat) => cat !== 'All'))
    }
    setCategory(selectedCategories.join(', '))
  }, [selectedCategories]) // eslint-disable-line

  const handleSortOrderChange = (order: string) => {
    setSortBy('name')
    setSortOrder(order)
  }

  const handleDealsPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setDealsPerPage(Number(event.target.value))
    setCurrentPage(1)
  }

  useEffect(() => {
    let handler: any
    if (search.length >= 3 || !search) {
      setLoading(true)
      handler = setTimeout(() => {
        getAllFounderMarketDeals()
      }, 200)
    }

    return () => {
      clearTimeout(handler)
    }
  }, [search]) // eslint-disable-line

  return (
    <>
      {/* <div className='d-flex align-items-start justify-content-between rounded bg-white p-2 gap-2'>
        <div className='d-flex flex-md-row flex-column gap-4'>
          <div className='d-flex'>
            <img className='rounded' src={FounderCrateBlueBG} alt="foundercrate logo" height={84} width={84} />
          </div>
          <div className='d-flex flex-column justify-content-between'>
            <div className='d-flex justify-content-between'>
              <div className='d-flex  align-items-center gap-4'>
                <div className='d-flex align-items-center justify-content-center rounded-pill px-4 py-1' style={{ background: '#F1FAFF', border: '1px solid #4776E633' }}>
                  <p className='m-0 font-size-13'>{formatMessage({ id: 'FOUNDER50' })}</p>
                </div>
                <div className='d-flex align-items-center justify-content-center rounded-pill px-4 py-1 text-warning' style={{ background: '#FFC90524', border: '1px solid #FFC90533' }}>
                  <p className='m-0 font-size-13'>{formatMessage({ id: 'Under Verification' })}</p>
                </div>
              </div>
            </div>
            <div className='d-flex flex-column flex-wrap gap-2 mt-2'>
              <h3 className='font-size-16 m-0'>{formatMessage({ id: 'Get 50% off on gold plan for 3 Months' })}</h3>
              <p className='m-0'>
                {isExpanded ? fullText : truncatedText}
                <span className='text-primary cursor-pointer' onClick={toggleReadMore}>
                  {isExpanded ? formatMessage({ id: 'Read Less' }) : formatMessage({ id: 'Read More' })}
                </span>
              </p>
            </div>
          </div>
        </div>
        <div className='d-flex'>
          <button className='btn btn-primary d-flex flex-wrap'
            onClick={() => setIsActiveModal(true)}>
            {formatMessage({ id: 'Edit My Deal' })}
          </button>
        </div>
      </div> */}
      {isactiveModal === true && <EditDealFounderMarket isModalActive={isactiveModal}
        setIsModalActive={setIsActiveModal} />}
      <div className='d-flex justify-content-between align-items-center my-4 gap-8'>
        <button
          className='d-flex align-items-center btn bg-white gap-2 p-4'
          onClick={() => setShowCategories(!showCategories)}
        >
          <img src={FilterIconFunnel} alt='' />
          <span className='d-none d-sm-block'>{formatMessage({ id: 'Filters' })}</span>
        </button>

        <div className='d-flex align-items-center gap-2'>
          <input
            type='text'
            className='bg-body form-control ps-4 rounded-2 font-size-13 font-weight-400'
            name='search'
            placeholder={formatMessage({ id: 'Search Deals' })}
            data-kt-search-element='input'
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <div className='card-toolbar' style={{ position: 'relative' }} ref={dropdownRef}>
            <Link
              to='#'
              className='btn bg-white rounded-2 p-3'
              onClick={toggleDropdown}
              aria-expanded={isOpen}
            >
              <img src={FilterIcon} alt={formatMessage({ id: 'Filter Icon' })} />
            </Link>
            {isOpen && (
              <div
                className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 bg-white shadow w-200px fw-semibold fs-7 py-2'
                style={{
                  position: 'absolute',
                  top: '110%',
                  right: 0,
                  zIndex: 1000,
                  display: isOpen ? 'block' : 'none',
                }}
              >
                <div className='menu-item px-2'>
                  <Link
                    to='#'
                    className={`menu-link px-2 ${sortOrder === 'ASC' ? 'text-primary' : ''}`}
                    onClick={() => handleSortOrderChange('ASC')}
                  >
                    {formatMessage({ id: 'Alphabetic (Ascending)' })}
                  </Link>
                </div>
                <div className='menu-item px-2'>
                  <Link
                    to='#'
                    className={`menu-link px-2 ${sortOrder === 'DESC' ? 'text-primary' : ''}`}
                    onClick={() => handleSortOrderChange('DESC')}
                  >
                    {formatMessage({ id: 'Alphabetic (Descending)' })}
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <Container fluid>
        <Row>
          {showCategories && (
            <Col xs={12} md={3} className='bg-white px-0 rounded-2 h-100 mb-4'>
              <div
                onClick={() => setOpen(!open)}
                aria-controls='category-collapse'
                aria-expanded={open}
                style={{ cursor: 'pointer' }}
              >
                <div className='d-flex justify-content-between align-items-center p-6'>
                  <h2 className='font-size-14 text-secondry'>
                    {formatMessage({ id: 'Categories' })}
                  </h2>
                  <img src={DropdownIcon} alt='' />
                </div>
              </div>
              <Collapse in={open}>
                <div id='category-collapse' className='px-6 h-100'>
                  <Form>
                    {categories.map((cat) => (
                      <Form.Check
                        key={cat.value}
                        type='checkbox'
                        label={formatMessage({ id: cat.label })}
                        className='mb-4'
                        style={{ color: '#383940' }}
                        value={cat.value}
                        checked={selectedCategories.includes(cat.value)}
                        onChange={handleCheckboxChange}
                      />
                    ))}
                  </Form>
                </div>
              </Collapse>
            </Col>
          )}
          <Col
            xs={12}
            md={showCategories ? 9 : 12}
            className={clsx('px-0 resource-section-v2', {
              'ps-4': showCategories,
              'ps-0': !showCategories,
            })}
          >
            {loading ? (
              Array(9)
                .fill(null)
                .map((_, index) => (
                  <div className='mb-4 rounded-2' key={index}>
                    <Skeleton
                      height={225}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                ))
            ) : (
              <>
                {loading ? (
                  <Skeleton
                    height={225}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                  />
                ) : founderMarketDeals.length === 0 ? (
                  <NoDataPage />
                ) : (
                  <div className='resources-list'>
                    {founderMarketDeals.map((deal: any, index: any) => (
                      <DealsFullWidthCard
                        key={index}
                        id={deal.marketDealId}
                        title={deal.name}
                        type={type}
                        category={deal.category}
                        image={deal.previewImage[0]}
                        description={deal.description}
                        showCategories={showCategories}
                        deal={deal.marketDealId}
                        bookmarked={deal.isBookmarkedDeal}
                      />
                    ))}
                  </div>
                )}
              </>
            )}

            {/* Pagination Section */}
            <div
              className={clsx('w-100 d-flex justify-content-between align-items-center px-0 mt-8', {
                'd-none': founderMarketDeals.length === 0,
              })}
            >
              <div className='d-flex gap-2 w-100 align-items-center'>
                <Form.Select
                  aria-label='Default select example'
                  className='px-4 py-3 w-80px'
                  value={dealsPerPage}
                  onChange={handleDealsPerPageChange}
                >
                  <option value='10'>{formatMessage({ id: '10' })}</option>
                  <option value='20'>{formatMessage({ id: '20' })}</option>
                  <option value='50'>{formatMessage({ id: '50' })}</option>
                  <option value='100'>{formatMessage({ id: '100' })}</option>
                </Form.Select>
                <span className='font-size-13'>
                  {/* Showing{' '}
                  {Math.min(
                    currentPage * dealsPerPage - dealsPerPage + 1,
                    type === 'deals' ? founderMarketDeals.length : founderMarketClaimedDeals.length
                  )}{' '}
                  to{' '}
                  {Math.min(
                    currentPage * dealsPerPage,
                    type === 'deals' ? founderMarketDeals.length : founderMarketClaimedDeals.length
                  )}{' '}
                  of{' '}
                  {type === 'deals' ? founderMarketDeals.length : founderMarketClaimedDeals.length}{' '}
                  records */}
                  {`Showing ${(currentPage - 1) * dealsPerPage + 1} to ${Math.min(
                    (currentPage - 1) * dealsPerPage + 1 + dealsPerPage - 1,
                    count
                  )} of ${count} records`}
                </span>
              </div>

              <Pagination className='w-100 d-flex flex-end'>
                <Pagination.First
                  key='first'
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(1)}
                />
                <Pagination.Prev
                  key='prev'
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((p) => p - 1)}
                />
                {pageNumbers.map((number) => (
                  <Pagination.Item
                    key={number}
                    active={number === currentPage}
                    onClick={() => setCurrentPage(number)}
                  >
                    {number}
                  </Pagination.Item>
                ))}
                {pageNumbers.length > 6 && (
                  <>
                    {currentPage < pageNumbers.length - 3 && <Pagination.Ellipsis />}
                    {currentPage >= pageNumbers.length - 3 && (
                      <Pagination.Item>{pageNumbers.length}</Pagination.Item>
                    )}
                  </>
                )}
                <Pagination.Next
                  key='next'
                  disabled={currentPage === pageNumbers.length}
                  onClick={() => setCurrentPage((p) => p + 1)}
                />
                <Pagination.Last
                  key='last'
                  disabled={currentPage === pageNumbers.length}
                  onClick={() => setCurrentPage(pageNumbers[pageNumbers.length - 1])}
                />
              </Pagination>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  )
}
